import { createSlice } from '@reduxjs/toolkit';

const initialState: { [key: string]: boolean } = {};

const verComentarioGuiaSlice = createSlice({
	name: 'verComentarioGuia',
	initialState,
	reducers: {
		setVerComentarioGuiaState: (state, action) => {
			return action.payload;
		},
		updateVerComentarioGuiaState: (state, action) => {
			return { ...state, ...action.payload };
		},
		resetVerComentarioGuiaState: () => initialState
	}
});

export const { setVerComentarioGuiaState, resetVerComentarioGuiaState, updateVerComentarioGuiaState } =
	verComentarioGuiaSlice.actions;
export default verComentarioGuiaSlice.reducer;
